import { Box, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import DocumentViewer from '../../../../Components/Ui/DocumentViewer';
import DocumentPaginationBar from '../ui/DocumentPaginationBar';

export default function M_WorkPlans_BASIC(props) {
  const { participantData, pageNumber } = useSelector((state) => state.tbm);
  const activeStep = useSelector((state) => state.common.activeStep);
  const fileUrl = props.fullUrl;
  const ext = props.getExtensionFromUrl(fileUrl);

  const isImage = ['jpg', 'jpeg', 'png'].includes(ext);
  const isPdf = ext === 'pdf';

  const renderViewer = () => {
    if (!fileUrl) {
      return (
        <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
          교육 자료가 없습니다.
        </Typography>
      );
    }

    if (isImage) {
      return (
        <img
          src={fileUrl}
          alt="교육자료 이미지"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '70vh',
            objectFit: 'contain',
          }}
        />
      );
    }

    if (isPdf) {
      return (
        <DocumentViewer
          fileUrl={fileUrl}
          renderPreview={props.renderPreview}
          loading={props.loading}
          onDocumentLoadSuccess={props.onDocumentLoadSuccess}
          pageNumber={pageNumber > 0 ? pageNumber : 1}
          pageWidth={props.pageWidth}
          pageViewHeight={props.pageViewHeight}
          setPageViewHeight={props.setPageViewHeight}
          renderTextLayer={false}
          renderAnnotationLayer={false}
          onError={props.onDocumentError}
        />
      );
    }

    return (
      <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
        미리보기를 지원하지 않는 파일 형식입니다.
      </Typography>
    );
  };

  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          작업계획서
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          파일 자료를 통해 작업계획서를 확인해주세요.
        </Typography>
      </Stack>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'auto',
          }}
        >
          {renderViewer()}
        </Box>

        <Box sx={{ flexShrink: 0, width: '100%' }}>
          {participantData.hostYn === 'Y' ? (
            <DocumentPaginationBar
              pageNumber={pageNumber > 0 ? pageNumber : 1}
              numPages={props.numPages}
              goToPrevPage={props.goToPrevPage}
              goToNextPage={props.goToNextPage}
              disabled={props.isTransitioning}
              onAdvanceStep={props.onAdvanceToNextStep}
              onSkipToNextStep={props.onAdvanceToNextStep}
            />
          ) : (
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
              <Typography
                component="div"
                sx={{
                  px: 2,
                  py: 0.75,
                  borderRadius: 999,
                  bgcolor: '#fff',
                  fontSize: 13,
                  fontWeight: 700,
                  color: '#333',
                  letterSpacing: '0.04em',
                  whiteSpace: 'nowrap',
                  border: '1px solid',
                  borderColor: 'rgba(0, 0, 0, 0.06)',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                }}
              >
                {props.numPages > 0
                  ? `${pageNumber > 0 ? pageNumber : 1} / ${props.numPages}`
                  : '—'}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}
